// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/liquidity_pfe_model.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's liquidity_pfe_model.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Frequency } from "./common_model_pb";
import { file_devtool_emodel_v1_common_model } from "./common_model_pb";
import type { PFEDataPrepConfig, RiskCalcMarketData, RiskCalcPricingConfig, RiskCalcTradeData } from "./risk_calc_engine_model_pb";
import { file_devtool_emodel_v1_risk_calc_engine_model } from "./risk_calc_engine_model_pb";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/liquidity_pfe_model.proto.
 */
export const file_devtool_emodel_v1_liquidity_pfe_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_devtool_emodel_v1_common_model, file_devtool_emodel_v1_risk_calc_engine_model, file_google_type_date]);

/**
 * @generated from message devtool.emodel.v1.LiquidityCounterparty
 */
export type LiquidityCounterparty = Message<"devtool.emodel.v1.LiquidityCounterparty"> & {
  /**
   * portfolio_id または "EEX/KGI" 等の合成ID
   *
   * @generated from field: string counterparty_id = 1;
   */
  counterpartyId: string;

  /**
   * @generated from field: devtool.emodel.v1.LiquidityCSADirection direction = 2;
   */
  direction: LiquidityCSADirection;

  /**
   * 対EEXは0
   *
   * @generated from field: double mta = 3;
   */
  mta: number;

  /**
   * Deprecated: margin_call_frequency を使うこと。単純な日数刻み
   * （暦日カウント、営業日非考慮）。margin_call_frequency が UNSPECIFIED の
   * ときだけフォールバックとして参照される。対EEXは1。
   *
   * @generated from field: int32 margin_call_frequency_days = 4 [deprecated = true];
   * @deprecated
   */
  marginCallFrequencyDays: number;

  /**
   * 既存 dataprep 入力を流用
   *
   * @generated from field: devtool.emodel.v1.PFEDataPrepConfig raw_trade_data = 5;
   */
  rawTradeData?: PFEDataPrepConfig;

  /**
   * 日次MTM・電力コスト等（既存形式）
   *
   * @generated from field: devtool.emodel.v1.RiskCalcMarketData market_data = 6;
   */
  marketData?: RiskCalcMarketData;

  /**
   * 変動証拠金差し入れ期日（マージンコールサイト、営業日数）。
   * 契約 margin_call_periods.due_day と同義で、着金日は与信PFEと同じ
   * NextNthBusinessDay(コール日, サイト+1, enechainカレンダー)。
   * 未設定 = 0 と同じ（翌営業日着金）。統一担保エンジンの残高は end-of-day
   * なので当日清算は表現されず、着金は常に翌グリッド日以降。評価期間外に
   * 着金するコールは CF に乗らない。
   *
   * @generated from field: optional int32 payment_lag_days = 7;
   */
  paymentLagDays?: number;

  /**
   * ハイブリッドスキームの銀行保証枠（JPY）。与信PFEの CollateralConfig.
   * standby_facility と同じ意味論: 顧客側マージンコールの不足分のみを相殺し
   * （コール = max(必要額 − 預託残 − 枠, 0)、預託パスの目標 = 必要額 − 枠）、
   * 返却方向・eClear側トラック・エクスポージャ系列には一切効かない
   * （督促を待てるだけでリスクは減らない）。0 = なし。
   *
   * @generated from field: double standby_facility = 8;
   */
  standbyFacility: number;

  /**
   * 基準日時点で eClear が保有する顧客預託金残高（JPY）。与信PFEの
   * CollateralConfig.clearer_held_deposit と同じ意味論: 顧客側トラックの
   * 預託残高の初期値としてシードされ、コールは必要額が残高を超えた分のみ、
   * 必要額が下回れば余剰は返却フローとして出る。0 = なし。
   *
   * @generated from field: double clearer_held_deposit = 9;
   */
  clearerHeldDeposit: number;

  /**
   * 基準日時点で顧客が保有する eClear 預託金残高（JPY）。eClear側トラックの
   * 初期値（clearer_held_deposit と同じシード意味論）。片側トラックが無効の方向
   * （eClearのみ/顧客のみ/無担保）では、無効トラックは残高凍結でフローを
   * 生まない（与信PFEの unilateral モードと同じ）。0 = なし。
   *
   * @generated from field: double customer_held_deposit = 10;
   */
  customerHeldDeposit: number;

  /**
   * 判定頻度。与信PFEの CollateralConfig.margin_call_frequency と同じ意味論:
   * 営業日（enechainカレンダー）のみ判定し、週次等の刻みは基準日翌日から
   * AddFrequency で進めて営業日に前進調整する。UNSPECIFIED のときは旧
   * margin_call_frequency_days（暦日刻み）にフォールバックする。
   *
   * @generated from field: devtool.emodel.v1.Frequency margin_call_frequency = 11;
   */
  marginCallFrequency: Frequency;

  /**
   * IM（当初証拠金アドオン、JPY）。与信PFEの CollateralConfig.initial_margin
   * と同一意味論: 顧客側必要額への定数加算（required^顧客 = max(MTM, 0) + IM、
   * ホライズン全体で一定）。返却時も IM が預託残高の床になる。eClear側
   * トラックには効かない。0 = なし。
   *
   * @generated from field: double initial_margin = 12;
   */
  initialMargin: number;

  /**
   * eClear側MTA（JPY）。与信PFEの CollateralConfig.mta_pay と同義で、eClear側
   * トラックのコール（eClear が差し入れる方向）のみをゲートする。mta は
   * 顧客側トラック（与信PFEの mta_receive）に対応する。未設定なら mta と
   * 同値（対称ゲート、従来挙動）。
   *
   * @generated from field: optional double eclear_mta = 13;
   */
  eclearMta?: number;

  /**
   * 顧客預託金の余剰を返却するか。与信PFEの CollateralConfig.
   * return_customer_collateral と同じ意味論・同じ既定: false = 返却しない
   * （顧客側の不足は 0 フロア・返却経路は閉じ、顧客預託金は外生の入出金を
   * 除き単調非減少）。true で余剰返却（相互 = MTA ゲート付き負のコール、
   * 片務 = withdrawal 経路）。eClear 側トラック（ECLEAR_ONLY の返却含む）は
   * このフラグに関わらず常に返却あり（預託金の非対称性は与信PFEと同じ）。
   *
   * @generated from field: bool return_customer_collateral = 14;
   */
  returnCustomerCollateral: boolean;

  /**
   * 判定日タイミングの上書き（day_tenor → 判定日か）。与信PFEの
   * CollateralConfig.margin_call_timing と同じ意味論: 設定時は
   * margin_call_frequency / margin_call_frequency_days による判定日決定を
   * 置き換える。期中に判定頻度が変わる組織（例: Daily → Biweekly）を表現する。
   *
   * @generated from field: map<int32, bool> margin_call_timing = 15;
   */
  marginCallTiming: { [key: number]: boolean };

  /**
   * 与信PFEの CalculateRiskRequest と同じ「ネット済みポジション」入力。
   * raw_trade_data の代わりに trade_data + pricing_config を渡すと、eModel は
   * dataprep を通さずこのポジションでそのまま行列を組む。両方ある場合は trade_data を優先する。
   *
   * @generated from field: devtool.emodel.v1.RiskCalcTradeData trade_data = 16;
   */
  tradeData?: RiskCalcTradeData;

  /**
   * @generated from field: devtool.emodel.v1.RiskCalcPricingConfig pricing_config = 17;
   */
  pricingConfig?: RiskCalcPricingConfig;
};

/**
 * Describes the message devtool.emodel.v1.LiquidityCounterparty.
 * Use `create(LiquidityCounterpartySchema)` to create a new message.
 */
export const LiquidityCounterpartySchema: GenMessage<LiquidityCounterparty> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_liquidity_pfe_model, 0);

/**
 * @generated from message devtool.emodel.v1.CalculateLiquidityPFERequest
 */
export type CalculateLiquidityPFERequest = Message<"devtool.emodel.v1.CalculateLiquidityPFERequest"> & {
  /**
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * @generated from field: repeated devtool.emodel.v1.LiquidityCounterparty counterparties = 2;
   */
  counterparties: LiquidityCounterparty[];

  /**
   * 日数。空なら evaluation_days 1点
   *
   * @generated from field: repeated int32 horizons = 3;
   */
  horizons: number[];

  /**
   * 例 [9500, 9900]。空なら既定 95/99
   *
   * @generated from field: repeated int32 percentiles_bps = 4;
   */
  percentilesBps: number[];

  /**
   * 全社共通（シナリオ整合）
   *
   * @generated from field: int32 evaluation_days = 5;
   */
  evaluationDays: number;

  /**
   * 全社共通
   *
   * @generated from field: int32 evaluation_data_count = 6;
   */
  evaluationDataCount: number;

  /**
   * 日次系列出力を要求するか
   *
   * @generated from field: bool with_daily_series = 7;
   */
  withDailySeries: boolean;

  /**
   * true なら horizon × percentile ごとに、その endpoint percentile を実現した
   * シナリオ s* の日次トレース（scenario_traces）も返す。監査・検証用。
   *
   * @generated from field: bool with_scenario_traces = 8;
   */
  withScenarioTraces: boolean;

  /**
   * true なら contributions（各社の寄与）を出さない。各社の証拠金フロー行列を合算した時点で
   * 捨てられるので、行列のメモリが counterparty 数に比例しなくなる（全社バッチ向け）。
   * 合計行列から取る endpoint / running_max / daily_series の値は変わらない。
   * with_scenario_traces と同時には指定できない（トレースは各社の行列を要する）。
   *
   * @generated from field: bool skip_counterparty_contributions = 9;
   */
  skipCounterpartyContributions: boolean;
};

/**
 * Describes the message devtool.emodel.v1.CalculateLiquidityPFERequest.
 * Use `create(CalculateLiquidityPFERequestSchema)` to create a new message.
 */
export const CalculateLiquidityPFERequestSchema: GenMessage<CalculateLiquidityPFERequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_liquidity_pfe_model, 1);

/**
 * @generated from message devtool.emodel.v1.LiquidityPFEPoint
 */
export type LiquidityPFEPoint = Message<"devtool.emodel.v1.LiquidityPFEPoint"> & {
  /**
   * @generated from field: int32 horizon = 1;
   */
  horizon: number;

  /**
   * @generated from field: int32 percentile_bps = 2;
   */
  percentileBps: number;

  /**
   * CF(s,H) の percentile（H時点の純資金需要）
   *
   * @generated from field: double endpoint = 3;
   */
  endpoint: number;

  /**
   * max_{t<=H} CF(s,t) の percentile（期間内ピーク）
   *
   * @generated from field: double running_max = 4;
   */
  runningMax: number;
};

/**
 * Describes the message devtool.emodel.v1.LiquidityPFEPoint.
 * Use `create(LiquidityPFEPointSchema)` to create a new message.
 */
export const LiquidityPFEPointSchema: GenMessage<LiquidityPFEPoint> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_liquidity_pfe_model, 2);

/**
 * @generated from message devtool.emodel.v1.LiquidityCounterpartyContribution
 */
export type LiquidityCounterpartyContribution = Message<"devtool.emodel.v1.LiquidityCounterpartyContribution"> & {
  /**
   * @generated from field: string counterparty_id = 1;
   */
  counterpartyId: string;

  /**
   * @generated from field: int32 horizon = 2;
   */
  horizon: number;

  /**
   * @generated from field: int32 percentile_bps = 3;
   */
  percentileBps: number;

  /**
   * endpoint の percentile を実現したシナリオにおける、この社の CF 寄与
   *
   * @generated from field: double endpoint_contribution = 4;
   */
  endpointContribution: number;
};

/**
 * Describes the message devtool.emodel.v1.LiquidityCounterpartyContribution.
 * Use `create(LiquidityCounterpartyContributionSchema)` to create a new message.
 */
export const LiquidityCounterpartyContributionSchema: GenMessage<LiquidityCounterpartyContribution> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_liquidity_pfe_model, 3);

/**
 * @generated from message devtool.emodel.v1.LiquidityPFEDailySeries
 */
export type LiquidityPFEDailySeries = Message<"devtool.emodel.v1.LiquidityPFEDailySeries"> & {
  /**
   * @generated from field: int32 percentile_bps = 1;
   */
  percentileBps: number;

  /**
   * CF(s,t) = t 日までの全社純証拠金フローの累計 Σ_{u<=t} Σ_j F_j(s,u) の percentile。
   * 正 = eClear が立て替えている、負 = 顧客からネットで受け取っている。
   *
   * @generated from field: repeated double endpoint = 2;
   */
  endpoint: number[];

  /**
   * max_{u<=t} CF(s,u) の percentile
   *
   * @generated from field: repeated double running_max = 3;
   */
  runningMax: number[];
};

/**
 * Describes the message devtool.emodel.v1.LiquidityPFEDailySeries.
 * Use `create(LiquidityPFEDailySeriesSchema)` to create a new message.
 */
export const LiquidityPFEDailySeriesSchema: GenMessage<LiquidityPFEDailySeries> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_liquidity_pfe_model, 4);

/**
 * LiquidityScenarioTraceCounterparty は s* シナリオにおける1社分の日次トレース。
 *
 * @generated from message devtool.emodel.v1.LiquidityScenarioTraceCounterparty
 */
export type LiquidityScenarioTraceCounterparty = Message<"devtool.emodel.v1.LiquidityScenarioTraceCounterparty"> & {
  /**
   * @generated from field: string counterparty_id = 1;
   */
  counterpartyId: string;

  /**
   * MTM_j(s*, t)。エンジンへの入力（担保前・cashIO控除前の将来価値レベル）。
   *
   * @generated from field: repeated double mtm = 2;
   */
  mtm: number[];

  /**
   * F_j(s*, t)：着金日基準のキャッシュフロー
   * = clearer_deposit_flow − customer_deposit_flow。
   * 正 = eClear がこの社へ差し入れ。コールは翌営業日以降の着金日に計上され
   * （残高は end-of-day なので当日清算は表現されない）、評価期間外に着金する
   * コールは落ちる。
   *
   * @generated from field: repeated double funding = 3;
   */
  funding: number[];

  /**
   * eClear 側トラックのコール額（コール日基準）。ECLEAR_ONLY では eClear が
   * 差し入れる方向のコール。差し入れ期日の影響を受けない契約上のスケジュール。
   *
   * @generated from field: repeated double eclear_call = 4;
   */
  eclearCall: number[];

  /**
   * 顧客側トラックのコール額（コール日基準。返却有効時の返却は負）。
   *
   * @generated from field: repeated double customer_call = 5;
   */
  customerCall: number[];

  /**
   * ---- 統一担保エンジンの内訳系列（与信PFEの定義ビューと同じ定義） ----
   * 顧客必要証拠金 = max(MTM, 0) + IM。
   *
   * @generated from field: repeated double required_customer_margin = 6;
   */
  requiredCustomerMargin: number[];

  /**
   * eClear必要証拠金 = max(−MTM, 0)。
   *
   * @generated from field: repeated double required_clearer_margin = 7;
   */
  requiredClearerMargin: number[];

  /**
   * eClear保有の顧客預託金残高（end-of-day、外生の入出金 = cashIO 込み）。
   *
   * @generated from field: repeated double clearer_held_deposit = 8;
   */
  clearerHeldDeposit: number[];

  /**
   * 顧客保有のeClear預託金残高（end-of-day）。
   *
   * @generated from field: repeated double customer_held_deposit = 9;
   */
  customerHeldDeposit: number[];

  /**
   * 顧客側ネット = 顧客必要証拠金 − 顧客預託金。
   *
   * @generated from field: repeated double customer_net = 10;
   */
  customerNet: number[];

  /**
   * eClear側ネット = eClear必要証拠金 − eClear預託金。
   *
   * @generated from field: repeated double clearer_net = 11;
   */
  clearerNet: number[];

  /**
   * 両建てネット = 顧客側ネット − eClear側ネット。
   *
   * @generated from field: repeated double net_position = 12;
   */
  netPosition: number[];

  /**
   * net_exposure = max(両建てネット, 0)。
   *
   * @generated from field: repeated double net_exposure = 13;
   */
  netExposure: number[];

  /**
   * 顧客預託金の日次フロー（着金日基準: 請求の着金＋返却。証拠金起因の分だけで、
   * 外生入出金（cashIO の入出金予定）は含まない。入出金予定は流動性キャッシュフロー
   * レポートが別途計上するため、ここに載せると二重計上になる。
   * したがって入出金予定のある日は clearer_held_deposit の日次デルタとその分だけ差がある）。
   *
   * @generated from field: repeated double customer_deposit_flow = 14;
   */
  customerDepositFlow: number[];

  /**
   * eClear預託金の日次フロー（着金日基準）。
   *
   * @generated from field: repeated double clearer_deposit_flow = 15;
   */
  clearerDepositFlow: number[];
};

/**
 * Describes the message devtool.emodel.v1.LiquidityScenarioTraceCounterparty.
 * Use `create(LiquidityScenarioTraceCounterpartySchema)` to create a new message.
 */
export const LiquidityScenarioTraceCounterpartySchema: GenMessage<LiquidityScenarioTraceCounterparty> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_liquidity_pfe_model, 5);

/**
 * LiquidityScenarioTrace は endpoint percentile を実現したシナリオ s* の
 * 完全な日次内訳（各社 MTM → コール → 合計 → 累積）。points の endpoint は
 * cumulative[horizon-1] と一致する。
 *
 * @generated from message devtool.emodel.v1.LiquidityScenarioTrace
 */
export type LiquidityScenarioTrace = Message<"devtool.emodel.v1.LiquidityScenarioTrace"> & {
  /**
   * @generated from field: int32 horizon = 1;
   */
  horizon: number;

  /**
   * @generated from field: int32 percentile_bps = 2;
   */
  percentileBps: number;

  /**
   * s* のシナリオ番号（0-based）。同一入力なら再現される
   *
   * @generated from field: int32 scenario_index = 3;
   */
  scenarioIndex: number;

  /**
   * Σ_j F_j(s*, t)
   *
   * @generated from field: repeated double total_funding = 4;
   */
  totalFunding: number[];

  /**
   * CF(s*, t) = total_funding の prefix-sum
   *
   * @generated from field: repeated double cumulative = 5;
   */
  cumulative: number[];

  /**
   * @generated from field: repeated devtool.emodel.v1.LiquidityScenarioTraceCounterparty counterparties = 6;
   */
  counterparties: LiquidityScenarioTraceCounterparty[];
};

/**
 * Describes the message devtool.emodel.v1.LiquidityScenarioTrace.
 * Use `create(LiquidityScenarioTraceSchema)` to create a new message.
 */
export const LiquidityScenarioTraceSchema: GenMessage<LiquidityScenarioTrace> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_liquidity_pfe_model, 6);

/**
 * @generated from message devtool.emodel.v1.CalculateLiquidityPFEResponse
 */
export type CalculateLiquidityPFEResponse = Message<"devtool.emodel.v1.CalculateLiquidityPFEResponse"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.LiquidityPFEPoint points = 1;
   */
  points: LiquidityPFEPoint[];

  /**
   * @generated from field: repeated devtool.emodel.v1.LiquidityCounterpartyContribution contributions = 2;
   */
  contributions: LiquidityCounterpartyContribution[];

  /**
   * with_daily_series=true の場合のみセット
   *
   * @generated from field: repeated devtool.emodel.v1.LiquidityPFEDailySeries daily_series = 3;
   */
  dailySeries: LiquidityPFEDailySeries[];

  /**
   * with_scenario_traces=true の場合のみ。points と同順
   *
   * @generated from field: repeated devtool.emodel.v1.LiquidityScenarioTrace scenario_traces = 4;
   */
  scenarioTraces: LiquidityScenarioTrace[];
};

/**
 * Describes the message devtool.emodel.v1.CalculateLiquidityPFEResponse.
 * Use `create(CalculateLiquidityPFEResponseSchema)` to create a new message.
 */
export const CalculateLiquidityPFEResponseSchema: GenMessage<CalculateLiquidityPFEResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_liquidity_pfe_model, 7);

/**
 * LiquidityCSADirection は証拠金授受の方向。片方向は該当トラックの required を 0 に固定する。
 *
 * @generated from enum devtool.emodel.v1.LiquidityCSADirection
 */
export enum LiquidityCSADirection {
  /**
   * @generated from enum value: LIQUIDITY_CSA_DIRECTION_UNSPECIFIED = 0;
   */
  LIQUIDITY_CSA_DIRECTION_UNSPECIFIED = 0,

  /**
   * 双方向（多くの個社）
   *
   * @generated from enum value: LIQUIDITY_CSA_DIRECTION_BIDIRECTIONAL = 1;
   */
  LIQUIDITY_CSA_DIRECTION_BIDIRECTIONAL = 1,

  /**
   * 相手だけ拠出（対D社型）: eClear側 required ≡ 0
   *
   * @generated from enum value: LIQUIDITY_CSA_DIRECTION_CUSTOMER_ONLY = 2;
   */
  LIQUIDITY_CSA_DIRECTION_CUSTOMER_ONLY = 2,

  /**
   * 自分たちだけ拠出（対EEX型）: 顧客側 required ≡ 0
   *
   * @generated from enum value: LIQUIDITY_CSA_DIRECTION_ECLEAR_ONLY = 3;
   */
  LIQUIDITY_CSA_DIRECTION_ECLEAR_ONLY = 3,

  /**
   * 無担保（証拠金授受なし、DMA等）: 両トラック ≡ 0 でフローは常に0
   *
   * @generated from enum value: LIQUIDITY_CSA_DIRECTION_NONE = 4;
   */
  LIQUIDITY_CSA_DIRECTION_NONE = 4,
}

/**
 * Describes the enum devtool.emodel.v1.LiquidityCSADirection.
 */
export const LiquidityCSADirectionSchema: GenEnum<LiquidityCSADirection> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_liquidity_pfe_model, 0);

